import { fork } from 'redux-saga/effects';

import { actions, selectors } from 'domain/substrate';
import { listNavigator } from 'sagas/common';
import { filters } from 'filters/substrate';

export default function* navigator() {
  yield fork(listNavigator, { modelName: 'Substrate', actions, selectors, filters } );
}
